import { DashboardOutlined, PictureOutlined } from '@ant-design/icons'
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import CIMSLink from '../../../../components/CIMSLink'
import { useGlobalState } from '../../../../context/GlobalStateContext'
import { useEffect, useState } from 'react'
import { useAuthContext } from '../../../../context/AuthContext'

export function useExternals(): ItemType[] {
  const {
    state: { projectGlobalId },
  } = useGlobalState()
  const { user } = useAuthContext()
  const [sharePointUrl, setSharePointUrl] = useState<string | undefined>(
    undefined
  )
  const [projectName, setProjectName] = useState<string | undefined>(undefined)
  useEffect(() => {
    const { sharePoint, name } =
      user?.projects?.find(({ id }) => id === projectGlobalId) ?? {}
    setSharePointUrl(sharePoint?.url ?? sharePoint?.site.url)
    setProjectName(name)
    return () => {
      setSharePointUrl(undefined)
      setProjectName(undefined)
    }
  }, [user, projectGlobalId])
  if (!projectGlobalId) return []
  return [
    {
      key: 'sharepoint',
      icon: <DashboardOutlined />,
      label: (
        <CIMSLink
          external
          href={sharePointUrl}
          tooltip={
            !sharePointUrl
              ? `There doesn't appear to be a SharePoint site associated with ${
                  projectName ?? 'this project'
                }`
              : undefined
          }
        >
          SharePoint
        </CIMSLink>
      ),
    },
    {
      key: 'photoViewer',
      icon: <PictureOutlined />,
      label: (
        <CIMSLink
          external
          href={
            !projectName
              ? undefined
              : `https://cimsapps.horrocks.com/photoviewer/?project=${projectName}`
          }
          tooltip={
            !projectName
              ? 'Unable to link to the Photo Viewer for this project'
              : undefined
          }
        >
          Photo Viewer
        </CIMSLink>
      ),
    },
  ]
}
